<template>
  <div class="container-main-body">
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="4">
            <div class="search-form-label">客户名称：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="客户名称"
                clearable
                v-model="query.customerName"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
        </el-button-group>
      </div>
      <div class="el-table-container">
        <el-table
          :data="ds"
          stripe
          border
          default-expand-all
          row-key="id"
          height="100%"
          size="mini"
          style="width: 100%; border:1px solid #d1d1d1;"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
          @selection-change="selectHandler"
          :tree-props="{ children: 'children' }"
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
            :selectable="selectableHandler"
          ></el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            label="客户名称"
            prop="name"
            width="300"
            header-align="center"
          ></el-table-column>
          <el-table-column label="所在区域" width="300" header-align="center"
            ><template v-slot:default="scope">{{
              scope.row.province + scope.row.city + scope.row.district
            }}</template></el-table-column
          >
          <el-table-column
            label="备注"
            prop="remark"
            header-align="center"
          ></el-table-column>
          <el-table-column label="操作" width="60" align="center">
            <template v-slot:default="scope">
              <el-button
                v-if="scope.row.creater_id === operator_id || editable === '是'"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
                plain
                @click.stop.prevent="viewHandler(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="query.pn"
          :page-size="query.pageSize"
          :total="query.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 表单对话框 -->
    <ezz-dialog-form ref="DForm" :parent="this" />
  </div>
</template>

<script>
import EzzDialogForm from "@/views/modules/crm/customer/Form.vue";
export default {
  data: function() {
    return {
      ds: [],
      selectedIds: [],
      // queryData中的属性与后端接收数据对象的属性是对应的，否则无法将数据传递到后端
      query: {
        customerName: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id")
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getCustomers, this.query, function(res) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.query.totalCount = _json.totalCount;
        }
      });
    },
    // 新增
    addHandler: function() {
      this.$refs.DForm.addHandler();
    },
    // 删除
    delHandler: function() {
      let _this = this;
      let _ids = _this.selectedIds.join(",");

      if (_ids.length === 0) {
        _this.$message({
          type: "warning",
          message: "至少选择一条数据"
        });
      } else {
        _this
          .$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            let _params = {
              ids: _ids,
              operator_id: _this.operator_id
            };
            // ajax提交至服务器，删除数据
            _this.post(_this.$apis.delCustomers, _params, function(res) {
              let _json = res.data;
              if (_json.status === "ok") {
                _this.loadData();
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                _this.$message({
                  type: "error",
                  message: "无数据更新!"
                });
              }
            });
          })
          .catch(() => {
            _this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    // 浏览
    viewHandler: function(_row) {
      let _formId = _row.id;
      this.$refs.DForm.viewHandler(_formId);
    },

    // 搜索事件
    searchHandler: function(_type) {
      this.query.pn = 1;
      if (_type === "clear") {
        this.query.customerName = "";
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 多选事件
    selectHandler: function(selection) {
      this.selectedIds = [];
      for (let _i = 0; _i < selection.length; ++_i) {
        this.selectedIds.push(selection[_i].id);
      }
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    pageChange: function(pn) {
      this.query.pn = pn;
      this.loadData();
    },
    pageSizeChange: function(pageSize) {
      this.query.pn = 1;
      this.query.pageSize = pageSize;
      this.loadData();
    },
    // 通过该方法，控制列表 checkbox 列是否允许勾选
    selectableHandler: function(_row, _index) {
      let delable = this.$store.state.delable;
      // 函数需要一个返回值,true为可选,false为不可选择
      return this.operator_id === _row.creater_id || delable === "是";
    }
  },
  components: {
    EzzDialogForm
  }
};
</script>
